<template>
  <b-tab @click="refreshTable()">
    <template #title>
      <span class="d-none d-sm-inline-block">
        {{ $t('master.list.rfid.reader.title') }}
      </span>
    </template>
    <!-- Table -->
    <div class="table-responsive mb-5">
      <McGrapqlTable
        v-if="isTableDataAvailable"
        ref="table-ref"
        :fields="fields"
        :apiClient="query"
        :searchable="true"
        :hasDelete="false"
        :cardPadding="false"
        :customHandlers="customHandlers"
        :hasDisabled="true"
        :hasCheckbox="false"
        trackBy="vehicleId"
      >
        <!-- Slot: Reader Type Column -->
        <template #cell(readerType)="data">
          {{ data.item.vehicle.sensor.sensorCode === 39 ? 'Immobilizer' : 'Identifier' }}
        </template>

        <!-- Slot: Driver Column -->
        <template #cell(driver)="data">
          {{ displayDriver(data.item.driverData) }}
        </template>
      </McGrapqlTable>

      <!-- Empty State -->
      <div v-show="!isTableDataAvailable" class="empty-table-container">
        <McEmptyState
          :title="$t('master.list.rfid.reader.emptyState')"
          :desc="$t('master.list.rfid.reader.emptyStateDesc')"
          :hasButton="false"
          class="pb-4"
        />
      </div>
    </div>
  </b-tab>
</template>
<script>
import { mapGetters } from 'vuex'
import McGrapqlTable from '@/components/McGrapqlTable'
import McEmptyState from '@/components/McEmptyState'
import { Helper } from '@/mixin/helper'
import { GET_RFID_READERS } from '@/services/api/master/rfid'
export default {
  components: {
    McGrapqlTable,
    McEmptyState,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: false,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('master.list.rfid.reader.vehicle'),
          thClass: 'mc-table--200',
          isSortable: true,
          isRedirectable: true,
        },
        {
          key: 'readerType',
          label: this.$t('master.list.rfid.reader.readerType'),
          thClass: 'mc-table--200',
        },
        {
          key: 'driver',
          label: this.$t('master.list.rfid.reader.driver'),
          thClass: 'mc-table--50',
        },
      ]
    },
    query() {
      return {
        get: async (opts) => {
          const res = await this.$apollo.query({
            query: GET_RFID_READERS,
            variables: {
              filter: {
                orderBy: opts.orderBy,
                search: opts.search,
                pagination: {
                  page: opts.pagination.page,
                  show: opts.pagination.show,
                },
                vehicleIds: opts.vehicleIds,
              },
            },
            fetchPolicy: 'no-cache',
          })

          res.data.getRfidReaders.getRfidReaders.data =
            res.data.getRfidReaders.getRfidReaders.data.map((item) => {
              return {
                ...item,
                state: item.vehicle.sensor.statusText,
                readerType: item.vehicle.sensor.sensorType.sensorName,
                licensePlate: item.vehicle.licensePlate,
              }
            })
          if (res.data.getRfidReaders.getRfidReaders.data.length > 0) {
            this.isTableDataAvailable = true
          }
          return res.data.getRfidReaders.getRfidReaders
        },
      }
    },
    resourcefulQuery() {
      return {}
    },
    customHandlers() {
      return {
        handleDisabledRow: this.handleDisabledRow,
        handleClickRow: this.handleClickRow,
      }
    },
  },
  mounted() {
    this.query.get({
      pagination: {
        page: 1,
        show: 9999,
      },
    })
  },
  methods: {
    handleClickRow(data) {
      this.$router.push({
        name: 'RFID Reader Detail',
        params: { id: data.vehicleId },
      })
    },
    handleDisabledRow(data) {
      return data.state === 'P' || data.readerType === 'RFID'
    },
    refreshTable() {
      this.query.get({
        pagination: {
          page: 1,
          show: 9999,
        },
      })

      if (this.$refs['table-ref']) {
        this.$refs['table-ref'].handleUnselectAll()
        this.$refs['table-ref'].getData({
          limit: this.$refs['table-ref'].limit,
          page: 1,
          sorts: this.$refs['table-ref'].stringSorts(),
        })
      }
    },
    displayDriver(data) {
      if (!Array.isArray(data)) return ''
      const withDriver = data.filter((item) => item.driver !== null)
      const withoutDriver = data.filter((item) => item.driver === null)
      const sortedWithDriver = withDriver.sort((a, b) => a.deviceIndex - b.deviceIndex)
      const sortedData = [...sortedWithDriver, ...withoutDriver]
      if (sortedData.length === 0) {
        return '-'
      }

      const allNulls = sortedData.every((item) => item.rfid === null && item.driver === null)
      if (allNulls) {
        return '-'
      }

      const formattedData = sortedData.map((item) => {
        if (item.rfid === null && item.driver === null) {
          return null
        } else if (item.rfid !== null && item.driver === null) {
          return '-'
        } else if (item.driver !== null) {
          return item.driver.fullname
        }
        return ''
      })

      if (formattedData.includes(null)) {
        const nonNullData = formattedData.filter((item) => item !== null)
        return nonNullData.length === 1 ? nonNullData[0] : nonNullData.join(', ')
      }

      return formattedData.length === 1 ? formattedData[0] : formattedData.join(', ')
    },
  },
}
</script>
